import { postApiCall} from "../utils/Api";

export const RevenueSummary = async (data) => {
    try {
      const result = await postApiCall(`/api/v1/dashboard/getrevanuesumary`,data,true);
      var apiresult = JSON.parse(result.data.message);
      //console.log(apiresult)
      return apiresult;
    } catch (e) {
      throw e;
    }
  };